module.exports = __webpack_public_path__ + "img/icon64.2dd0ea93.png";